export interface MovieItem {
  id: number;
  title: string;
  category: string;
  year: string;
  rating: string;
  region: string;
  desc: string;
  image: string;
  link: string;
}

export const categoryMovies: Record<string, MovieItem[]> = {
  movie: [
    {
      id: 101, title: '封神第二部', category: '奇幻 / 动作', year: '2026', rating: '8.8', region: '中国大陆', desc: '商周大战全面爆发，封神榜即将揭晓最终篇章。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20movie%20poster%20style%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20dramatic%20lighting%2C%20ancient%20Chinese%20mythology%20theme%2C%20dark%20rich%20background%2C%20professional%20film%20design&width=400&height=600&seq=cat-mv-01&orientation=portrait',
      link: '/article/4',
    },
    {
      id: 102, title: '速度与激情10', category: '动作 / 冒险', year: '2026', rating: '8.5', region: '美国', desc: '家族再度集结，面对前所未有的危机。极速狂飙，极限追逐！',
      image: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20fast%20cars%20and%20explosions%2C%20warm%20orange%20and%20amber%20cinematic%20tones%2C%20dramatic%20lighting%2C%20Hollywood%20blockbuster%20style%2C%20dark%20rich%20background%2C%20professional%20design&width=400&height=600&seq=cat-mv-02&orientation=portrait',
      link: '/article/1',
    },
    {
      id: 103, title: '流浪地球3', category: '科幻 / 灾难', year: '2026', rating: '9.1', region: '中国大陆', desc: '人类命运的最后抉择，太阳系之外的未知世界。中国科幻巅峰之作！',
      image: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20with%20spaceship%20and%20cosmic%20theme%2C%20warm%20golden%20nebula%20tones%2C%20dramatic%20cinematic%20lighting%2C%20dark%20space%20background%2C%20professional%20film%20design%2C%20clean%20composition&width=400&height=600&seq=cat-mv-03&orientation=portrait',
      link: '/article/2',
    },
    {
      id: 104, title: '哪吒之魔童闹海', category: '动画 / 奇幻', year: '2026', rating: '9.3', region: '中国大陆', desc: '天命难违，我命由我不由天。全新篇章，视觉盛宴！',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20warm%20crimson%20and%20golden%20tones%2C%20mythological%20theme%20with%20fire%20elements%2C%20dramatic%20lighting%2C%20dark%20atmospheric%20background%2C%20professional%20design&width=400&height=600&seq=cat-mv-04&orientation=portrait',
      link: '/article/3',
    },
    {
      id: 105, title: '满江红2', category: '悬疑 / 历史', year: '2026', rating: '8.1', region: '中国大陆', desc: '南宋临安，一场更大的阴谋正在浮出水面。',
      image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20mystery%20movie%20poster%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20Song%20Dynasty%20aesthetic%2C%20dramatic%20shadows%2C%20dark%20atmospheric%20background%2C%20professional%20film%20design&width=400&height=600&seq=cat-mv-05&orientation=portrait',
      link: '/article/7',
    },
    {
      id: 106, title: '巨齿鲨3', category: '动作 / 科幻', year: '2026', rating: '7.9', region: '美国', desc: '深海巨兽再度来袭，人类面临史前猎食者的终极挑战。',
      image: 'https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20poster%20with%20giant%20shark%20in%20ocean%2C%20dramatic%20orange%20and%20teal%20contrast%2C%20Hollywood%20style%2C%20dark%20underwater%20background%2C%20professional%20film%20design%2C%20clean%20composition&width=400&height=600&seq=cat-mv-06&orientation=portrait',
      link: '/article/8',
    },
    {
      id: 107, title: '消失的她2', category: '悬疑 / 犯罪', year: '2026', rating: '8.4', region: '中国大陆', desc: '新的谜案，更深的人性考验，真相远比想象中更加残酷。',
      image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20with%20dark%20suspenseful%20atmosphere%2C%20warm%20amber%20accents%2C%20noir%20style%20lighting%2C%20professional%20film%20design%2C%20dark%20rich%20background&width=400&height=600&seq=cat-mv-07&orientation=portrait',
      link: '/article/9',
    },
    {
      id: 108, title: '长安三万里2', category: '动画 / 历史', year: '2026', rating: '8.6', region: '中国大陆', desc: '盛唐诗篇续写传奇，李白与杜甫的千年之约。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20movie%20poster%2C%20Tang%20Dynasty%20poetic%20aesthetic%2C%20warm%20golden%20tones%2C%20elegant%20composition%2C%20dark%20rich%20background%2C%20professional%20film%20design&width=400&height=600&seq=cat-mv-08&orientation=portrait',
      link: '/article/5',
    },
  ],
  tv: [
    {
      id: 201, title: '庆余年3', category: '古装 / 权谋', year: '2026', rating: '9.0', region: '中国大陆', desc: '范闲的身世之谜终于揭晓，京都风云再起，权谋与江湖的巅峰对决。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20warm%20golden%20and%20amber%20tones%2C%20ancient%20palace%20aesthetic%2C%20cinematic%20lighting%2C%20dark%20rich%20background%2C%20professional%20TV%20series%20design&width=400&height=600&seq=cat-tv-01&orientation=portrait',
      link: '/article/10',
    },
    {
      id: 202, title: '狂飙2', category: '犯罪 / 剧情', year: '2026', rating: '8.7', region: '中国大陆', desc: '扫黑除恶行动全面升级，更大的保护伞浮出水面。',
      image: 'https://readdy.ai/api/search-image?query=Crime%20drama%20Chinese%20TV%20series%20poster%2C%20dark%20intense%20atmosphere%2C%20warm%20amber%20accents%2C%20noir%20style%2C%20suspenseful%20mood%2C%20professional%20design%2C%20dark%20rich%20background&width=400&height=600&seq=cat-tv-02&orientation=portrait',
      link: '/article/11',
    },
    {
      id: 203, title: '三体：黑暗森林', category: '科幻 / 悬疑', year: '2026', rating: '9.2', region: '中国大陆', desc: '黑暗森林法则正式揭晓，人类文明面临外星文明的终极考验。',
      image: 'https://readdy.ai/api/search-image?query=Sci-fi%20Chinese%20TV%20series%20poster%2C%20cosmic%20theme%20with%20stars%20and%20nebula%2C%20warm%20orange%20golden%20tones%2C%20mysterious%20atmosphere%2C%20dark%20space%20background%2C%20professional%20design&width=400&height=600&seq=cat-tv-03&orientation=portrait',
      link: '/article/12',
    },
    {
      id: 204, title: '大江大河3', category: '剧情 / 年代', year: '2026', rating: '9.1', region: '中国大陆', desc: '改革开放进入深水区，宋运辉等人的命运再次迎来转折。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20period%20drama%20poster%2C%20reform%20era%20aesthetic%2C%20warm%20nostalgic%20golden%20tones%2C%20professional%20TV%20design%2C%20dark%20rich%20background%2C%20clean%20composition&width=400&height=600&seq=cat-tv-04&orientation=portrait',
      link: '/article/15',
    },
    {
      id: 205, title: '琅琊榜3', category: '古装 / 权谋', year: '2026', rating: '9.4', region: '中国大陆', desc: '金陵城下风云变幻，新一代谋士的传奇故事。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20political%20drama%20poster%2C%20warm%20amber%20and%20golden%20tones%2C%20ancient%20Chinese%20aesthetic%2C%20elegant%20design%2C%20dark%20rich%20background%2C%20professional%20composition&width=400&height=600&seq=cat-tv-05&orientation=portrait',
      link: '/article/16',
    },
    {
      id: 206, title: '人世间2', category: '剧情 / 家庭', year: '2026', rating: '8.9', region: '中国大陆', desc: '光字片的故事还在继续，平凡人家的不平凡岁月。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20TV%20series%20poster%2C%20warm%20nostalgic%20tones%2C%20everyday%20life%20aesthetic%2C%20soft%20lighting%2C%20professional%20design%2C%20dark%20rich%20background&width=400&height=600&seq=cat-tv-06&orientation=portrait',
      link: '/article/17',
    },
  ],
  variety: [
    {
      id: 301, title: '奔跑吧第12季', category: '真人秀 / 娱乐', year: '2026', rating: '7.8', region: '中国大陆', desc: '全新阵容，全新挑战，欢乐继续升级！',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20vibrant%20energetic%20colors%2C%20warm%20coral%20and%20amber%20tones%2C%20fun%20dynamic%20atmosphere%2C%20entertainment%20TV%20aesthetic%2C%20bright%20colorful%20design&width=400&height=600&seq=cat-vr-01&orientation=portrait',
      link: '/article/13',
    },
    {
      id: 302, title: '向往的生活第8季', category: '生活 / 慢综艺', year: '2026', rating: '8.3', region: '中国大陆', desc: '回归自然，享受简单生活。新一季的蘑菇屋等你来！',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20life%20variety%20show%20poster%2C%20warm%20natural%20golden%20tones%2C%20countryside%20aesthetic%2C%20cozy%20atmosphere%2C%20professional%20entertainment%20design%2C%20clean%20composition&width=400&height=600&seq=cat-vr-02&orientation=portrait',
      link: '/article/18',
    },
    {
      id: 303, title: '歌手2026', category: '音乐 / 竞演', year: '2026', rating: '8.5', region: '中国大陆', desc: '顶级歌手巅峰对决，谁是2026最强音？',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20competition%20show%20poster%2C%20dramatic%20stage%20lighting%2C%20warm%20amber%20and%20golden%20tones%2C%20professional%20entertainment%20design%2C%20dark%20rich%20background%2C%20clean%20composition&width=400&height=600&seq=cat-vr-03&orientation=portrait',
      link: '/article/19',
    },
    {
      id: 304, title: '吐槽大会第7季', category: '脱口秀 / 喜剧', year: '2026', rating: '8.0', region: '中国大陆', desc: '最犀利的吐槽，最爆笑的段子。全新嘉宾阵容！',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20talk%20show%20poster%2C%20warm%20vibrant%20tones%2C%20fun%20energetic%20atmosphere%2C%20stage%20lighting%2C%20entertainment%20design%2C%20clean%20professional%20composition&width=400&height=600&seq=cat-vr-04&orientation=portrait',
      link: '/article/20',
    },
  ],
  anime: [
    {
      id: 401, title: '仙逆', category: '玄幻 / 动画', year: '2026', rating: '8.9', region: '中国大陆', desc: '凡人修仙，逆天改命。王林的热血修仙之路！',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20animation%20poster%2C%20fantasy%20cultivation%20theme%2C%20warm%20golden%20and%20crimson%20tones%2C%20ethereal%20glowing%20effects%2C%20dark%20mystical%20background%2C%20professional%20anime%20design&width=400&height=600&seq=cat-an-01&orientation=portrait',
      link: '/article/14',
    },
    {
      id: 402, title: '凡人修仙传', category: '仙侠 / 动画', year: '2026', rating: '9.0', region: '中国大陆', desc: '韩立踏入修仙界，斗法、修炼、成长的热血故事。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20donghua%20poster%2C%20warm%20golden%20and%20emerald%20tones%2C%20fantasy%20martial%20arts%20theme%2C%20ethereal%20atmosphere%2C%20dark%20mystical%20background%2C%20professional%20anime%20design&width=400&height=600&seq=cat-an-02&orientation=portrait',
      link: '/article/21',
    },
    {
      id: 403, title: '斗破苍穹', category: '玄幻 / 动画', year: '2026', rating: '8.7', region: '中国大陆', desc: '萧炎的斗气大陆冒险，强者为尊的热血世界。',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20donghua%20poster%20with%20fire%20and%20battle%20elements%2C%20warm%20crimson%20and%20golden%20tones%2C%20epic%20atmosphere%2C%20dark%20rich%20background%2C%20professional%20anime%20design&width=400&height=600&seq=cat-an-03&orientation=portrait',
      link: '/article/22',
    },
    {
      id: 404, title: '鬼灭之刃柱集训篇', category: '动作 / 日漫', year: '2026', rating: '9.1', region: '日本', desc: '炭治郎接受柱特训，为最终决战做准备！',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20sword%20fighting%20theme%2C%20warm%20crimson%20and%20golden%20tones%2C%20dramatic%20atmosphere%2C%20dark%20rich%20background%2C%20professional%20anime%20design&width=400&height=600&seq=cat-an-04&orientation=portrait',
      link: '/article/23',
    },
  ],
};

export const categoryInfo: Record<string, { name: string; desc: string; keywords: string }> = {
  movie: {
    name: '电影',
    desc: '院线大片、经典佳作、高分必看电影大全，聚合飘花电影网、555电影、8090电影网最新高清电影资源',
    keywords: '电影大全,最新电影,高清电影,飘花电影网,555电影,8090电影网,免费在线观看',
  },
  tv: {
    name: '电视剧',
    desc: '热播剧集、高分国剧、海外精选电视剧大全，每日更新最新电视剧资源，高清流畅不缓冲',
    keywords: '电视剧,最新电视剧,热播剧集,高清电视剧,免费在线观看,不缓冲',
  },
  variety: {
    name: '综艺',
    desc: '热门综艺、搞笑娱乐、真人秀综艺节目大全，聚合各大平台最新综艺资源',
    keywords: '综艺节目,热门综艺,真人秀,娱乐节目,免费在线观看',
  },
  anime: {
    name: '动漫',
    desc: '国漫崛起、日漫经典、剧场版动漫大全，最新最全的动漫资源一站式观看',
    keywords: '动漫,国漫,日漫,动画片,高清动漫,免费在线观看',
  },
};